<template>
    <div class="row justify-content-center mt-2">
        <input :type="type" v-bind:class="'form-control col-1 ' + (errors !== null ? 'error-input' : '')" :name="name" :id="name" type="checkbox" :value="modelValue" @input="updateValue($event.target.checked)">
        <label class="col-11 text-justify" :for="name"> <strong v-if="required" class="text-danger">*</strong> {{ label }}</label>
        <div class="error col-12" v-if="errors">
            <ul>
                <li v-for="error in errors" :key="error">{{ error }}</li>
            </ul>
        </div>
    </div>
</template>

<script>
export default {
    props: ['label', 'type', 'name', 'require', 'errorMessages', 'modelValue'],

    methods: {
        updateValue(value) {
            this.$emit('input', value === true ? 1 : 0);
            if(this.errorMessages && this.name in this.errorMessages) {
                this.value = value;
            }
        }
    },
    data() {
        return {
            value: '',
            required: this.require,
        };
    },
    computed: {
        errors: function () {
            if(this.errorMessages && this.name in this.errorMessages && this.value === '') {
                return this.errorMessages[this.name];
            }

            return null;
        }
    },
    watch: {
        errorMessages: function(newValue, oldValue) {
            this.value = '';
        }
    }
}
</script>
